
<div>
  <section style="top: 350px;overflow-y: scroll;height: 32%;width:100% ;">

  <div class="wrapper">

  <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
  <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 74%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>
  <button type="button" class="add-boutton" style="left: 83%;" name="Add" [disabled]="disablepharnacy" (click)="openDialog()" >Add</button>
  </div>


<BR>
<BR>

 <table style="left: 50px;width: 90%;">
<!-- style="font-size: {{wk_fontsize}}; text-align: left;" -->
  <tr *ngFor="let clinic of otherClinicList ; let i = index" >
    <td>

      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
           <label style="font-weight: bold;">{{clinic.clinicdate}}  {{clinic.username}} -- {{clinic.docdepartment}}   </label>   <label for=""> ({{cliniclocationtext[i]}})</label>
        </div>
        <div>
          <button class="fa fa-pencil" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: green;" matTooltip="Edit" name="Add" (click)=" Editotherclinic(clinic)"  ></button>
          <button class="fa fa-trash" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: red;" matTooltip="Delete" name="Delete"  (click)="MessegeDelete(clinic)"></button>
        </div>
      </div>
      <angular-editor [(ngModel)]="clinic.clinicnotes" [config]="editorConfigNoToolbar" style="border: none !important; box-shadow: none !important;"
    >

      </angular-editor>
      <br>
      <br>
    </td>
  </tr>
</table>
</section>


